// src/pages/projects/GatewayCard.jsx

const GATEWAY_LOGOS = {
  payu:     "/payu-logo.svg",
  cashfree: "/cashfree-logo.svg",
  paytm:    "/paytm-logo.svg",
  paypal:   "/paypal-logo.svg",
  razorpay: "/razorpay-logo.svg",
};

export default function GatewayCard({
  gatewayKey,
  label,
  value,
  openDrawer,
  onToggle,
}) {
  const enabled = value?.enabled || false;
  const configured = value?.configured || false;

  return (
    <div
      className={`border rounded-2xl p-5 cursor-pointer transition relative
      ${enabled ? "border-indigo-500 shadow-lg" : "border-gray-300 hover:shadow"}
    `}
      onClick={() => {
        if (enabled) openDrawer(gatewayKey);
      }}
    >
      <div className="flex items-center justify-between mb-2">
        <img
          src={GATEWAY_LOGOS[gatewayKey]}
          alt={label}
          className="h-8 object-contain"
          onError={(e) => {
            e.target.style.display = "none";
            e.target.nextSibling.style.display = "block";
          }}
        />
        <span style={{ display: "none" }} className="text-lg font-semibold">{label}</span>

        <button
          className={`px-3 py-1 text-sm rounded-full border transition
          ${enabled ? "bg-indigo-600 text-white border-indigo-600" : "bg-gray-100 border-gray-300"}
        `}
          onClick={(e) => {
            e.stopPropagation();
            onToggle(gatewayKey, !enabled);
            if (!enabled) {
              openDrawer(gatewayKey);
            }
          }}
        >
          {enabled ? "Disable" : "Enable"}
        </button>
      </div>

      <p
        className={`text-sm ${
          configured ? "text-green-600 font-medium" : "text-gray-500"
        }`}
      >
        {configured ? "Configured" : enabled ? "Configure Gateway" : "Not Enabled"}
      </p>
    </div>
  );
}